// extracted by mini-css-extract-plugin
export default {"icon":"GroupRemoveItem_icon__Qtvg-","button":"GroupRemoveItem_button__Z1wqb"};